module.exports = __webpack_public_path__ + "static/media/officer-up.f5926d5f.jpg";